<template>
  <div class="search-nav" :class="{ 'only-search': !topicVisible }">
    <div class="search">
      <div class="search-left">
        <YorkbbsImage class="topic-logo" width="112px" :src="require('@/assets/images/info/logo.png')" link="/"
          alt="约克黄页:多伦多最全中文分类黄页信息平台"></YorkbbsImage>
      </div>
      <div class="search-center">
        <el-input class="search-input" clearable placeholder="请输入类别名称或关键字​" v-model="keyword"
          @keyup.enter.native="handleSearch">
          <button class="search-button" slot="append" @click="handleSearch">
            <i class="yk-search_forum"></i>
          </button>
        </el-input>
      </div>
      <div class="search-right">
        <div class="search-button__list">
          <router-link class="search-button__item" to="/publish">
            <el-button type="danger">
              <i class="yk-house_write"></i>
              <span>发布黄页</span>
            </el-button>
          </router-link>
          <a class="search-button__item" target="_blank" :href="'/' | hostBuild('merchant')">
            <el-button>
              <i class="yk-house_user"></i>
              <span>管理黄页</span>
            </el-button>
          </a>
        </div>
      </div>
    </div>
    <nav class="nav" v-if="topicVisible">
      <div class="nav-wrapper">
        <router-link class="nav-item" :class="{ active: $route.name == 'Home' }" to="/">
          <span>首页</span>
        </router-link>
              
          <router-link class="nav-item" v-for="(topic, i) in topics" :key="i" :to="`/${topic.url}/${topic.englishName}`"
            :class="{ active: topic.englishName == _topic }" >
            <span>{{ topic.name }}</span>
            <img class="nav-item__hot" :src="require('@/assets/images/info/hot.png')" alt="热门" v-if="topic.hot == 1" />
          </router-link>
       
      </div>
    </nav>
  </div>
</template>
<script>
export default {
  name: 'SearchNav',
  props: {
    // 板块显示状态
    topicVisible: {
      type: Boolean,
      default: true,
    },
    // 一级板块信息
    topTopic: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      // 搜索关键词
      keyword: '',

      // 板块
      topics: [
        { name: '接送搬家', englishName: 'movingservices', url: 'list' },
        { name: '购房服务', englishName: 'houseservice', url: 'list' },
        { name: '装修家居', englishName: 'house', hot: 1, url: 'list' },
        { name: '汽车服务', englishName: 'car' , url: 'list'},
        { name: '法律金融', englishName: 'lawfinance', hot: 1 , url: 'list'},
        { name: '生活服务', englishName: 'lifeservices', url: 'list' },
        { name: '培训', englishName: 'education' , url: 'list'},
        { name: '丽人医美', englishName: 'fashion' , url: 'list'},
        { name: '医疗保健', englishName: 'medical' , url: 'list'},
        { name: '商业', englishName: 'bizservice' , url: 'list'},
        { name: '超市', englishName: 'shopping' , url: 'shoplist'},
        { name: '运动', englishName: 'sports' , url: 'shoplist'},
        { name: '常用电话', englishName: 'chinesephone' , url: 'shoplist'},
        { name: '娱乐', englishName: 'entertainment' , url: 'shoplist'},
        { name: '美食', englishName: 'restaurants', hot: 1 , url: 'restaurantlist'},
      ],
      // 板块加载状态
      loading: false,
    };
  },
  computed: {
    // 当前一级板块短名
    _topic() {
      return this.topics.find(t => t.englishName == this.$route.params.topic)
        ? this.$route.params.topic
        : this.topTopic.englishName;
    },
  },
  created() {
    this.keyword = this.$route.query.keyword || '';
  },
  methods: {
    /**
     * 搜索
     */
    handleSearch() {
      const keyword = this.keyword.trim();

      if (this.$route.name === 'Search') {
        this.$router.push({ query: { ...this.$route.query, keyword } });
      } else {
        window.open(`/search?keyword=${keyword}`);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.search-nav {
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);

  &.only-search {
    .search {
      padding: 17px 0;
    }
  }
}

.search {
  width: 1170px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: auto;
  padding: 14px 0;
}

.search-input {
  width: 533px;

  ::v-deep {
    .el-input__inner {
      border-right: 0 none;
      border-top-left-radius: 6px;
      border-bottom-left-radius: 6px;
    }

    .el-input-group__append {
      padding: 0;
      border: 0 none;

      i {
        color: #fff;
      }
    }
  }

  .search-button {
    width: 52px;
    height: 40px;
    background-color: var(--primary-color);
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;

    &:hover {
      background: #e96161;
      border-color: #e96161;
      color: #fff;
    }
  }
}

.search-button__list {
  display: flex;
}

.search-button__item {
  display: block;

  &:not(:last-child) {
    margin-right: 20px;
  }

  ::v-deep {
    .el-button {
      font-size: 16px;

      i {
        margin-right: 6px;
      }
    }
  }
}

::v-deep {
  .el-dropdown-menu__item {
    width: 128px;
    box-sizing: border-box;

    a {
      display: block;
    }
  }
}

.search-right {
  display: flex;
  align-items: center;
}

.nav {
  background: linear-gradient(to bottom, #fff, #fafafa);
}

.nav-wrapper {
  height: 52px;
  width: 1170px;
  margin: auto;
  display: flex;
  justify-content: space-between;
}

.nav-item {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  color: var(--text-color-3);
  position: relative;
  transition: all 0.2s;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    height: 4px;
    background-color: transparent;
    border-radius: 2px;
    transition: all 0.2s;
  }

  &.active {
    &::after {
      background-color: var(--primary-color);
    }
  }

  &:hover {
    color: var(--primary-color);
  }
}

.nav-item__hot {
  position: absolute;
  width: 26px;
  height: 18px;
  right: -14px;
  top: 0;
  z-index: 1;
}
</style>
